<template>
  <div>
    <MasterLayout>
      <section class="mt-3 full__row_section">
        <div class="row align-items-center" style="height: 100%">
          <div class="col-lg-4">
            <div class="dashboard__card large_card">
              <div
                class="small__card_content_wrapper align-items-center justify-content-center"
              >
                <p class="dashboard__card__header text-white">
                  {{ $t("text.iTankProbe.totalTransactions") }}
                </p>
                <div
                  class="icon_wrapper centralize text-center"
                  style="margin-top: -12px"
                >
                  <img src="@/assets/img/wallet.svg" width="40px" />
                </div>
                <div class="">
                  <small
                    class="dashboard__card__header_bottom text-white font-weight-bold"
                    >{{ transactionCount }}</small
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-8">
            <div
              class="dashboard__card large_card card_padding indus_back_img_lg"
            >
              <div
                class="row make-row-hundred-percent align-items-center justify-content-center"
              >
                <div class="col-md-5 remove-padding-left">
                  <h4 class="text-white">
                    {{ $t("text.iTankProbe.tankProbeTransactions") }}
                  </h4>
                </div>
                <div class="col-md-5 remove-padding-left">
                  <div class="date_picker_m">
                    <vue-ctk-date-time-picker
                      v-model="dateRange"
                      :max-date="maxDate"
                      :range="true"
                      :autoClose="true"
                      :custom-shortcuts="customShortcuts"
                      color="#290C53"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.iTankProbe.dateRange')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-8 remove-padding-left padding_div">
            <div class="dashboard__card small_card align-center">
              <div
                class="row align-items-center justify-content-center"
                style="height: 100%; width: 100%; margin: auto"
              >
                <div class="col-md-6">
                  <h5>Tank Probe Transactions</h5>
                </div>
                <div class="col-md-6 mt-4">
                  <div class="drop_down_div align-items-center" style="height:100%; width:100%; ">
                    <vue-ctk-date-time-picker
                      v-model="dateRange"
                      :max-date="maxDate"
                      :range="true"
                      :autoClose="true"
                      :custom-shortcuts="customShortcuts"
                      color="#290C53"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      label="Select a date range"
                    />
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>
            </div>
          </div> -->
        </div>
      </section>
      <section class="top_section_row mt-3">
        <div class="row mt-3 align-items-center py-3">
          <div class="col-md-8">
            <span class="pl-3">
              {{ $t("text.iTankProbe.tanksFilled") }}
              <strong>{{ startDate }} </strong> and
              <strong>{{ endDate }} </strong></span
            >
          </div>
          <div class="col-md-4 text-right"></div>
        </div>
      </section>
      <div class="new_row_section mt-3">
        <ejs-grid
          ref="dataGrid"
          v-show="!showLoader"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="tableProps.pageSettings"
          :toolbar="tableProps.toolbar"
          :searchSettings="tableProps.search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :dataSource="tableProps.tableData"
          :locale="usedLang"
          v-cloak
        >
          <e-columns>
            <e-column width="80" field="index" headerText="#"></e-column>
            <e-column
              width="200"
              field="date"
              :headerText="$t('text.iTankProbe.date')"
            ></e-column>
            <e-column
              width="150"
              field="productHeight"
              :headerText="$t('text.iTankProbe.productHeight')"
            ></e-column>
            <e-column
              width="150"
              field="productVolume"
              :headerText="$t('text.iTankProbe.productVolume')"
            ></e-column>
            <e-column
              width="150"
              field="temprature"
              :headerText="$t('text.iTankProbe.temperature')"
            ></e-column>
            <e-column
              width="150"
              field="waterHeight"
              :headerText="$t('text.iTankProbe.waterHeight')"
            ></e-column>
            <e-column
              width="150"
              field="waterVolume"
              :headerText="$t('text.iTankProbe.waterVol')"
            ></e-column>
            <!-- <e-column
              :template="tanksTemplate"
              headerText="Action"
              width="250"
            ></e-column> -->
          </e-columns>
        </ejs-grid>
        <TableLoader :showLoader="showLoader" />
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
// import transactionTemp from '@/components/Templates/tanksTransactionsTemplate.vue';
import Jquery from "jquery";
let $ = Jquery;

export default {
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  created() {
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;

    this.$eventHub.$on("refreshProbeTransactions", () => {
      this.getTankTransactions();
    });
  },
  mounted() {
    this.getTankTransactions();

    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid =
        document.getElementsByClasstankName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getTankTransactions();
      }
    },
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      transactionCount: 0,
      tableProps: {
        pageSettings: { pageSizes: [50, 100, 200], pageCount: 4, pageSize: 50 },
        toolbar: ["ExcelExport", "PdfExport", "Search"],
        search: { operator: "contains", ignoreCase: true },
      },
      showLoader: false,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      startDate: this.$moment().format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      branchName: "",
      tanksTemplate: function () {
        return {
          template: transactionTemp,
        };
      },
    };
  },
  methods: {
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            filetankName: "branches.pdf",
          };
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    getTankTransactions() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Tank/ProbeTransactions/${this.$route.query.tankId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          let index = 0;
          response.data.sort((a, b) => {
            if (a.date !== b.date) {
              return a.date > b.date ? -1 : a.date < b.date ? 1 : 0;
            }
          });
          response.data.forEach((element) => {
            element.index = ++index;
            element.date = this.$moment(element.date).format(
              "MMMM Do YYYY, hh:mm A"
            );
            element.productVolume = this.convertThousand(element.productVolume);
            element.waterVolume = this.convertThousand(element.waterVolume);
            element.productHeight = this.convertThousand(element.productHeight);
            element.waterHeight = this.convertThousand(element.waterHeight);
          });
          this.transactionCount = response.data.length;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .full__row_section h3,
  .full__row_section p {
    font-size: 15px !important;
    text-align: center !important;
  }
}
.large_card {
  background-image: url("../../../../assets/img/longBG.png") !important;
  background-size: cover !important;
  background-position: 20% 20% !important;
}
</style>
